import { uuid } from '../../mixins/uuid'

export const toggleDrawer = (state, operate) => {
  state[operate.target] = operate.value === undefined ? !state[operate.target] : operate.value
}
export const assignValue = (state, values) => {
  Object.keys(values).forEach(key => {
    state[key] = values[key]
  })
}

export const pushSnackbar = (state, snackbar) => {
  state.snackbars.unshift(snackbar)
}
export const removeSnackbar = (state, id) => {
  const index = _.findIndex(state.snackbars, {
    id: id
  })
  if (index > -1) {
    state.snackbars.splice(index, 1)
  }
}

export const pushMqttMessage = (state, message) => {
  state.mqttMessages.push(Object.assign({
    id: uuid(),
    topic: _.concat('', message.topic.split('/').slice(1, -1)).join('/')
  }, JSON.parse(message.payloadString)))
}
export const shiftMqttMessage = (state) => {
  state.mqttMessages.shift()
}

export const MQTT_SEND = () => {}
export const MQTT_CONNECT = () => {}
export const MQTT_DISCONNECT = () => {}
export const MQTT_FAILED = state => {
  state.mqttFailed = true
}
export const MQTT_SUBSCRIBE = (state, topic) => {
  state.mqttTopics = _.uniq(_.concat(state.mqttTopics, topic))
  sessionStorage.setItem('mqtt_topics', state.mqttTopics.join('|'))
}
export const MQTT_UNSUBSCRIBE = (state, topic) => {
  state.mqttTopics = _.pull(state.mqttTopics, topic)
  sessionStorage.setItem('mqtt_topics', state.mqttTopics.join('|'))
}
